"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var react_web_components_1 = require("@nimles/react-web-components");

var react_compound_slider_1 = require("react-compound-slider"); // *******************************************************
// RAIL
// *******************************************************


var railOuterStyle = {
  position: 'absolute',
  width: '100%',
  height: 42,
  transform: 'translate(0%, -50%)',
  borderRadius: 7,
  cursor: 'pointer'
};
var railInnerStyle = {
  position: 'absolute',
  width: '100%',
  height: 14,
  transform: 'translate(0%, -50%)',
  borderRadius: 7,
  pointerEvents: 'none',
  backgroundColor: 'rgb(155,155,155)'
};

exports.SliderRail = function (_a) {
  var getRailProps = _a.getRailProps;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", __assign({
    style: railOuterStyle
  }, getRailProps())), react_1.default.createElement("div", {
    style: railInnerStyle
  }));
};

exports.Handle = function (_a) {
  var _b = _a.domain,
      min = _b[0],
      max = _b[1],
      _c = _a.handle,
      id = _c.id,
      value = _c.value,
      percent = _c.percent,
      _d = _a.disabled,
      disabled = _d === void 0 ? false : _d,
      getHandleProps = _a.getHandleProps;
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", __assign({
    style: {
      left: percent + "%",
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      WebkitTapHighlightColor: 'rgba(0,0,0,0)',
      zIndex: 5,
      width: 28,
      height: 42,
      cursor: 'pointer',
      backgroundColor: 'none'
    }
  }, getHandleProps(id))), react_1.default.createElement("div", {
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    style: {
      left: percent + "%",
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      zIndex: 2,
      width: 24,
      height: 24,
      borderRadius: '50%',
      boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
      backgroundColor: disabled ? '#666' : '#9BBFD4'
    }
  }));
}; // *******************************************************
// KEYBOARD HANDLE COMPONENT
// Uses a button to allow keyboard events
// *******************************************************


exports.KeyboardHandle = function (_a) {
  var _b = _a.domain,
      min = _b[0],
      max = _b[1],
      _c = _a.handle,
      id = _c.id,
      value = _c.value,
      percent = _c.percent,
      _d = _a.disabled,
      disabled = _d === void 0 ? false : _d,
      getHandleProps = _a.getHandleProps;
  return react_1.default.createElement("button", __assign({
    role: "slider",
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuenow": value,
    style: {
      left: percent + "%",
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      zIndex: 2,
      width: 24,
      height: 24,
      borderRadius: '50%',
      boxShadow: '1px 1px 1px 1px rgba(0, 0, 0, 0.3)',
      backgroundColor: disabled ? '#666' : '#9BBFD4'
    }
  }, getHandleProps(id)));
};

exports.Track = function (_a) {
  var source = _a.source,
      target = _a.target,
      getTrackProps = _a.getTrackProps,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b;
  return react_1.default.createElement("div", __assign({
    style: {
      position: 'absolute',
      transform: 'translate(0%, -50%)',
      height: 14,
      zIndex: 1,
      backgroundColor: disabled ? '#999' : '#607E9E',
      borderRadius: 7,
      cursor: 'pointer',
      left: source.percent + "%",
      width: target.percent - source.percent + "%"
    }
  }, getTrackProps()));
};

exports.Tick = function (_a) {
  var tick = _a.tick,
      count = _a.count,
      _b = _a.format,
      format = _b === void 0 ? function (d) {
    return d;
  } : _b;
  return react_1.default.createElement("div", null, react_1.default.createElement("div", {
    style: {
      position: 'absolute',
      marginTop: 14,
      width: 1,
      height: 5,
      backgroundColor: 'rgb(200,200,200)',
      left: tick.percent + "%"
    }
  }), react_1.default.createElement("div", {
    style: {
      position: 'absolute',
      marginTop: 22,
      fontSize: 10,
      textAlign: 'center',
      marginLeft: -(100 / count) / 2 + "%",
      width: 100 / count + "%",
      left: tick.percent + "%"
    }
  }, format(tick.value)));
};

var sliderStyle = {
  position: 'relative',
  width: '100%',
  touchAction: 'none'
};

var SliderInput = function SliderInput(_a) {
  var field = _a.field,
      // { name, value, onChange, onBlur }
  _b = _a.form,
      errors = _b.errors,
      setFieldValue = _b.setFieldValue,
      // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label = _a.label,
      required = _a.required,
      info = _a.info,
      min = _a.min,
      max = _a.max,
      isMulti = _a.isMulti;
  var domain = [min, max];
  var values = field.value ? isMulti ? field.value : [field.value] : [min];
  return react_1.default.createElement(react_1.default.Fragment, null, label && react_1.default.createElement(react_web_components_1.Label, {
    required: required,
    info: info
  }, label), react_1.default.createElement("div", null, react_1.default.createElement(react_compound_slider_1.Slider, {
    mode: 1,
    step: 1,
    domain: domain,
    rootStyle: sliderStyle,
    onChange: function onChange(values) {
      if (isMulti) {
        setFieldValue(field.name, values);
      } else if (values[0] !== field.value) {
        setFieldValue(field.name, values[0]);
      }
    },
    values: values
  }, react_1.default.createElement(react_compound_slider_1.Rail, null, function (_a) {
    var getRailProps = _a.getRailProps;
    return react_1.default.createElement(exports.SliderRail, {
      getRailProps: getRailProps
    });
  }), react_1.default.createElement(react_compound_slider_1.Handles, null, function (_a) {
    var handles = _a.handles,
        getHandleProps = _a.getHandleProps;
    return react_1.default.createElement("div", {
      className: "slider-handles"
    }, handles.map(function (handle) {
      return react_1.default.createElement(exports.Handle, {
        key: handle.id,
        handle: handle,
        domain: domain,
        getHandleProps: getHandleProps
      });
    }));
  }), react_1.default.createElement(react_compound_slider_1.Tracks, {
    right: false
  }, function (_a) {
    var tracks = _a.tracks,
        getTrackProps = _a.getTrackProps;
    return react_1.default.createElement("div", {
      className: "slider-tracks"
    }, tracks.map(function (_a) {
      var id = _a.id,
          source = _a.source,
          target = _a.target;
      return react_1.default.createElement(exports.Track, {
        key: id,
        source: source,
        target: target,
        getTrackProps: getTrackProps
      });
    }));
  })), react_1.default.createElement("div", null, errors ? errors[field.name] : null)));
};

exports.SliderField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: SliderInput
  }));
};